// Get Invitations
export const GET_INVITATIONS_REQUEST = 'GET_INVITATIONS_REQUEST';
export const GET_INVITATIONS_DONE = 'GET_INVITATIONS_DONE';
export const GET_INVITATIONS_FAILED = 'GET_INVITATIONS_FAILED';

// Resend Invitation
export const RESEND_INVITATION_REQUEST = 'RESEND_INVITATION_REQUEST';
export const RESEND_INVITATION_DONE = 'RESEND_INVITATION_DONE';
export const RESEND_INVITATION_FAILED = 'RESEND_INVITATION_FAILED';
export const RESEND_INVITATION_RESET = 'RESEND_INVITATION_RESET';

// Delete Invitation
export const DELETE_INVITATION_REQUEST = 'DELETE_INVITATION_REQUEST';
export const DELETE_INVITATION_DONE = 'DELETE_INVITATION_DONE';
export const DELETE_INVITATION_FAILED = 'DELETE_INVITATION_FAILED';

// Save Columns Width
export const SAVE_INVITATIONS_COLUMNS = 'SAVE_INVITATIONS_COLUMNS';

// Operations
export const INVITATIONS_SET_PAGE = 'INVITATIONS_SET_PAGE';